//danh sách kỹ thuật viên
export const Member_Ship = [
  {
    id: 1,
    url: "/assets/NhanVien/03.jpg",
    img_data: [
      { url: "/assets/NhanVien/03.jpg" },
      { url: "/assets/NhanVien/05_4.jpg" },
    ],
    name: "MS_03",
    age: "2000",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Bắc",
    kg: "41",
    roud: "80-60-90",
  },
  {
    id: 2,
    url: "/assets/NhanVien/05_1.jpg",
    img_data: [
      { url: "/assets/NhanVien/05_2.jpeg" },
      { url: "/assets/NhanVien/05_3.jpg" },
      { url: "/assets/NhanVien/05_4.jpg" },
      { url: "/assets/NhanVien/05_5.jpg" },
    ],
    name: "MS_05",
    age: "2003",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Bắc",
    kg: "41",
    roud: "80-60-90",
  },
  {
    id: 3,
    url: "/assets/NhanVien/06.jpg",
    img_data: [
      { url: "/assets/NhanVien/06.jpg" },
      { url: "/assets/NhanVien/06.jpg" },
    ],
    name: "MS_06",
    age: "2004",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Bắc",
    kg: "41",
    roud: "80-60-90",
  },
  {
    id: 4,
    url: "/assets/NhanVien/07_1.jpg",
    img_data: [
      { url: "/assets/NhanVien/07_2.jpg" },
      { url: "/assets/NhanVien/07_3.jpg" },
      { url: "/assets/NhanVien/07_4.jpg" },
      { url: "/assets/NhanVien/07_1.jpg" },
    ],
    name: "MS_07",
    age: "2002",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Bắc",
    kg: "41",
    roud: "80-60-90",
  },
  {
    id: 5,
    url: "/assets/NhanVien/09.jpg",
    img_data: [
      { url: "/assets/NhanVien/09.jpg" },
      { url: "/assets/NhanVien/09.jpg" },
    ],
    name: "MS_09",
    age: "2002",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Bắc",
    kg: "41",
    roud: "80-60-90",
  }, {
    id: 6,
    url: "/assets/NhanVien/15.jpg",
    img_data: [
      { url: "/assets/NhanVien/15.jpg" },
      { url: "/assets/NhanVien/15_1.jpg" },
    ],
    name: "MS_15",
    age: "2000",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Bắc",
    kg: "41",
    roud: "80-60-90",
  },
  
  {
    id: 7,
    url: "/assets/NhanVien/18.jpg",
    img_data: [
      { url: "/assets/NhanVien/18.jpg" },
      { url: "/assets/NhanVien/18.jpg" },
    ],
    name: "MS_18",
    age: "2002",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Bắc",
    kg: "41",
    roud: "80-60-90",
  },
  
  {
    id: 8,
    url: "/assets/NhanVien/36.jpg",
    img_data: [
      { url: "/assets/NhanVien/36.jpg" },
      { url: "/assets/NhanVien/36.jpg" },
    ],
    name: "MS_36",
    age: "1997",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Bắc",
    kg: "41",
    roud: "80-60-90",
  },
  {
    id: 9,
    url: "/assets/NhanVien/38.jpg",
    img_data: [
      { url: "/assets/NhanVien/38.jpg" },
      { url: "/assets/NhanVien/38.jpg" },
    ],
    name: "MS_38",
    age: "2002",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Bắc",
    kg: "41",
    roud: "80-60-90",
  },
  {
    id: 10,
    url: "/assets/NhanVien/40.jpeg",
    img_data: [
      { url: "/assets/NhanVien/40_2.jpeg" },
      { url: "/assets/NhanVien/40_3.jpeg" },
    ],
    name: "MS_40",
    age: "2002",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Bắc",
    kg: "41",
    roud: "80-60-90",
  },
  {
    id: 11,
    url: "/assets/NhanVien/41.jpeg",
    img_data: [
      { url: "/assets/NhanVien/41_1.jpeg" },
      { url: "/assets/NhanVien/41.jpeg" },
    ],
    name: "MS_41",
    age: "2002",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Bắc",
    kg: "41",
    roud: "80-60-90",
  },
  {
    id: 12,
    url: "/assets/NhanVien/50.jpg",
    img_data: [
      { url: "/assets/NhanVien/50_1.jpg" },
      { url: "/assets/NhanVien/50_2.jpeg" },
    ],
    name: "MS_50",
    age: "2002",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Bắc",
    kg: "41",
    roud: "80-60-90",
  }, 
  {
    id: 13,
    url: "/assets/NhanVien/55.jpeg",
    img_data: [
      { url: "/assets/NhanVien/55.jpeg" },
      { url: "/assets/NhanVien/55.jpeg" },
    ],
    name: "MS_55",
    age: "2002",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Bắc",
    kg: "41",
    roud: "80-60-90",
  },

  {
    id: 14,
    url: "/assets/NhanVien/61_2.jpg",
    img_data: [
      { url: "/assets/NhanVien/61_1.jpg" },
      { url: "/assets/NhanVien/61.jpg" },
    ],
    name: "MS_61",
    age: "2002",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Bắc",
    kg: "41",
    roud: "80-60-90",
  },
  {
    id: 15,
    url: "/assets/NhanVien/62.jpg",
    img_data: [
      { url: "/assets/NhanVien/62.jpg" },
      { url: "/assets/NhanVien/62.jpg" },
    ],
    name: "MS_62",
    age: "1997",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Bắc",
    kg: "41",
    roud: "80-60-90",
  },
 
  {
    id: 16,
    url: "/assets/NhanVien/64.5.jpg",
    img_data: [
      { url: "/assets/NhanVien/64_1.jpg" },
      { url: "/assets/NhanVien/64.jpg" },
    ],
    name: "MS_64",
    age: "2004",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Bắc",
    kg: "41",
    roud: "80-60-90",
  },
  {
    id: 17,
    url: "/assets/NhanVien/66_1.jpg",
    img_data: [
      { url: "/assets/NhanVien/66_1.jpg" },
      { url: "/assets/NhanVien/66.jpg" },
    ],
    name: "MS_66",
    age: "1999",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Bắc",
    kg: "41",
    roud: "80-60-90",
  },
  {
    id: 18,
    url: "/assets/NhanVien/77.5.jpg",
    img_data: [
      { url: "/assets/NhanVien/77.jpg" },
      { url: "/assets/NhanVien/77.jpg" },
    ],
    name: "MS_77",
    age: "1993",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Bắc",
    kg: "41",
    roud: "80-60-90",
  },
  {
    id: 19,
    url: "/assets/NhanVien/80.jpg",
    img_data: [
      { url: "/assets/NhanVien/80.jpg" },
      { url: "/assets/NhanVien/80.jpg" },
    ],
    name: "MS_80",
    age: "1997",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Bắc",
    kg: "50",
    roud: "80-60-90",
  },
  {
    id: 20,
    url: "/assets/NhanVien/88.jpg",
    img_data: [
      { url: "/assets/NhanVien/88.jpg" },
      { url: "/assets/NhanVien/88_1.jpg" },
    ],
    name: "MS_88",
    age: "2006",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Bắc",
    kg: "41",
    roud: "80-60-90",
  },
  {
    id: 21,
    url: "/assets/NhanVien/89.jpg",
    img_data: [
      { url: "/assets/NhanVien/89.jpg" },
      { url: "/assets/NhanVien/89_1.jpg" },
    ],
    name: "MS_89",
    age: "2005",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Bắc",
    kg: "41",
    roud: "80-60-90",
  },
  {
    id: 22,
    url: "/assets/NhanVien/92.jpg",
    img_data: [
      { url: "/assets/NhanVien/92.jpg" },
      { url: "/assets/NhanVien/92_1.jpg" },
    ],
    name: "MS_92",
    age: "1991",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Bắc",
    kg: "41",
    roud: "80-60-90",
  },
  {
    id: 23,
    url: "/assets/NhanVien/95.jpg",
    img_data: [
      { url: "/assets/NhanVien/95.jpg" },
      { url: "/assets/NhanVien/95.jpg" },
    ],
    name: "MS_95",
    age: "1995",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Tây",
    kg: "41",
    roud: "80-60-90",
  },
  {
    id: 24,
    url: "/assets/NhanVien/97.jpg",
    img_data: [
      { url: "/assets/NhanVien/97.1.jpg" },
      { url: "/assets/NhanVien/97.2.jpg" },
    ],
    name: "MS_97",
    age: "2002",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Tây",
    kg: "41",
    roud: "80-60-90",
  },
  {
    id: 25,
    url: "/assets/NhanVien/98.jpg",
    img_data: [
      { url: "/assets/NhanVien/98.jpg" },
      { url: "/assets/NhanVien/98.jpg" },
    ],
    name: "MS_98",
    age: "2002",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Tây",
    kg: "41",
    roud: "80-60-90",
  },
  {
    id: 26,
    url: "/assets/NhanVien/99.jpg",
    img_data: [
      { url: "/assets/NhanVien/99.1.jpg" },
      { url: "/assets/NhanVien/99.2.jpg" },
    ],
    name: "MS_99",
    age: "2002",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Nam",
    kg: "41",
    roud: "80-60-90",
  },

  {
    id: 27,
    url: "/assets/NhanVien/112.jpg",
    img_data: [
      { url: "/assets/NhanVien/112.jpg" },
      { url: "/assets/NhanVien/112.jpg" },
    ],
    name: "MS_112",

    age: "2002",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Nam",
    roud: "80-60-90",
  },
  {
    id: 28,
    url: "/assets/NhanVien/116.jpg",
    img_data: [
      { url: "/assets/NhanVien/116.jpg" },
      { url: "/assets/NhanVien/116.jpg" },
    ],
    name: "MS_116",

    age: "1995",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Nam",
    roud: "80-60-90",
  },
  {
    id: 29,
    url: "/assets/NhanVien/117.jpg",
    img_data: [
      { url: "/assets/NhanVien/117.jpg" },
      { url: "/assets/NhanVien/117.jpg" },
    ],
    name: "MS_117",

    age: "1999",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Nam",
    roud: "80-60-90",
  },
  {
    id: 30,
    url: "/assets/NhanVien/118.jpg",
    img_data: [
      { url: "/assets/NhanVien/118.jpg" },
      { url: "/assets/NhanVien/118.jpg" },
    ],
    name: "MS_118",

    age: "2005",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Nam",
    roud: "80-60-90",
  },
   {
    id: 31,
    url: "/assets/NhanVien/119.jpg",
    img_data: [
      { url: "/assets/NhanVien/119.jpg" },
      { url: "/assets/NhanVien/119.jpg" },
    ],
    name: "MS_119",

    age: "2005",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Nam",
    roud: "80-60-90",
  },
   {
    id: 32,
    url: "/assets/NhanVien/123.jpg",
    img_data: [
      { url: "/assets/NhanVien/123.jpg" },
      { url: "/assets/NhanVien/123.jpg" },
    ],
    name: "MS_123",

    age: "2005",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Nam",
    roud: "80-60-90",
  },
  
  {
    id: 33,
    url: "/assets/NhanVien/124.jpg",
    img_data: [
      { url: "/assets/NhanVien/124.jpg" },
      { url: "/assets/NhanVien/124.jpg" },
    ],
    name: "MS_124",

    age: "2002",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Bắc",
    roud: "80-60-90",
  },

  {
    id: 34,
    url: "/assets/NhanVien/132.jpg",
    img_data: [
      { url: "/assets/NhanVien/132.jpg" },
      { url: "/assets/NhanVien/132.jpg" },
    ],
    name: "MS_132",

    age: "2002",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Nam",
    roud: "80-60-90",
  },
  {
    id: 35,
    url: "/assets/NhanVien/135.jpeg",
    img_data: [
      { url: "/assets/NhanVien/135.jpeg" },
      { url: "/assets/NhanVien/135.jpeg" },
    ],
    name: "MS_135",

    age: "2002",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Nam",
    roud: "80-60-90",
  },
  {
    id: 36,
    url: "/assets/NhanVien/136.jpeg",
    img_data: [
      { url: "/assets/NhanVien/136.jpeg" },
      { url: "/assets/NhanVien/136.jpeg" },
    ],
    name: "MS_136",

    age: "2002",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Nam",
    roud: "80-60-90",
  },
  {
    id: 37,
    url: "/assets/NhanVien/138.jpeg",
    img_data: [
      { url: "/assets/NhanVien/138.jpeg" },
      { url: "/assets/NhanVien/138.jpeg" },
    ],
    name: "MS_138",

    age: "2002",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Nam",
    roud: "80-60-90",
  },
  {
    id: 38,
    url: "/assets/NhanVien/140.jpeg",
    img_data: [
      { url: "/assets/NhanVien/140.jpeg" },
      { url: "/assets/NhanVien/140.jpeg" },
    ],
    name: "MS_140",

    age: "2002",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Nam",
    roud: "80-60-90",
  },
  {
    id: 39,
    url: "/assets/NhanVien/141.jpeg",
    img_data: [
      { url: "/assets/NhanVien/141.jpeg" },
      { url: "/assets/NhanVien/141.jpeg" },
    ],
    name: "MS_141",

    age: "2002",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Nam",
    roud: "80-60-90",
  },
  {
    id: 40,
    url: "/assets/NhanVien/142.jpeg",
    img_data: [
      { url: "/assets/NhanVien/142.jpeg" },
      { url: "/assets/NhanVien/142.jpeg" },
    ],
    name: "MS_142",

    age: "2002",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Nam",
    roud: "80-60-90",
  },
  {
    id: 41,
    url: "/assets/NhanVien/143.jpeg",
    img_data: [
      { url: "/assets/NhanVien/143.jpeg" },
      { url: "/assets/NhanVien/143.jpeg" },
    ],
    name: "MS_143",

    age: "2002",
    desc: "Chuyên viên massage",
    vote: "99",
    ex: "5 năm kinh nghiệm - Đào tạo bới Massage AIB",
    country: "Miền Nam",
    roud: "80-60-90",
  },
];